export const ar = {
  globals: {},
  auth: {
    emailId: " البريد الإلكتروني",
    password: "كلمة المرور",
    remember: "تذكرني",
    forgotPassword: "نسيت كلمة المرور",
    oldPass: "كلمة المرور القديمة",
    confmPas: "تأكيد كلمة المرور",
    otpVerification: "التحقق من OTP",
    verify: "تحقق",
    resendOtp: "إعادة إرسال OTP",
    login: "تسجيل الدخول",
    resendPass: "إعادة تعيين كلمة المرور",
    editProfile: "تعديل الملف الشخصي",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    loginToSura: "تسجيل الدخول إلى إدارة سورا تريد",
    emailAddress: "عنوان البريد الإلكتروني",
    verifyOtp: "تحقق من رمز التحقق",
    otpExpire: "ستنتهي صلاحية رمز التحقق خلال",
    otpResent: "تم إعادة إرسال رمز التحقق بنجاح",
  },

  main: {
    totalCustomers: "إجمالي العملاء",
    totalVendors: "إجمالي البائعين",
    totalOrders: "الطلبات الجارية",
    completedOrders: "الطلبات المكتملة",
    cancelledOrders: "الطلبات الملغاة",
    totalCategories: "إجمالي الفئات",
    totalSubCategories: "إجمالي الفئات الفرعية",
    totalRevenue: "إجمالي الإيرادات",
    totalProductsListed: "إجمالي المنتجات المدرجة",
    exportCsv: "تصدير CSV",
    sNo: "رقم",
    image: "صورة",
    fullName: "الاسم الكامل",
    phoneNumber: "رقم الهاتف",
    email: "البريد الإلكتروني",
    businessName: "اسم النشاط التجاري",
    industryType: "نوع الصناعة",
    address: "العنوان",
    manageAccount: "إدارة الحساب",
    reject: "رفض",
    accept: "قبول",
    pending: "قيد الانتظار",
    approved: "تمت الموافقة",
    rejected: "مرفوض",
    deactivate: "تم التعطيل",
    search: "ابحث هنا",
    accountStatus: "حالة الحساب",
    actions: "الإجراءات",
    name: "الاسم",
    subCategory: "الفئة الفرعية",
    addCategory: "إضافة فئة",
    viewSubCategories: "عرض الفئات الفرعية",
    selectCategory: "اختر فئة",
    selectSubCategory: "اختر فئة فرعية",
    clearFilter: "مسح الفلتر",
    addProduct: "إضافة منتج",
    productName: "اسم المنتج",
    vendorName: "اسم البائع",
    subCategoryName: "اسم الفئة الفرعية",
    parentCategory: "الفئة الرئيسية",
    manageProduct: "إدارة المنتج",
    status: "الحالة",
    todayDeals: "عروض اليوم",
    bestDeals: "أفضل العروض",
    customerName: "اسم العميل",
    inProgress: "قيد التنفيذ",
    category: "الفئة",
    productQuantity: "كمية المنتج",
    price: "السعر",
    specificReq: "متطلبات خاصة",
    chat: "دردشة",
    quoteStatus: "حالة العرض",
    sendQuote: "إرسال عرض",
    deliveryConditions: "شروط التوصيل",
    shippingCharge: "رسوم الشحن",
    freeDelivery: "توصيل مجاني",
    payment: "الدفع",
    refundable: "قابل للاسترداد",
    nonRefundable: "غير قابل للاسترداد",
    update: "تحديث",
    cancel: "إلغاء",
    orderId: "معرف الطلب",
    date: "التاريخ",
    refundAmount: "مبلغ الاسترداد",
    amountSetByVendor: "المبلغ المحدد من قبل البائع",
    refund: "استرداد",
    refundPayment: "دفع الاسترداد",
    addBanner: "إضافة بانر",
    banner: "بانر",
    discountName: "اسم الخصم",
    discountPercentage: "نسبة الخصم",
    description: "الوصف",
    type: "النوع",
    bannerType: "نوع البانر",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    addDiscount: "إضافة خصم",
    onGoing: "جارٍ التنفيذ",
    completed: "مكتمل",
    orderTrackId: "معرف تتبع الطلب",
    userName: "اسم المستخدم",
    subTotal: "الإجمالي الفرعي",
    totalCost: "التكلفة الإجمالية",
    deliveryFees: "رسوم التوصيل",
    shippingAddress: "عنوان الشحن",
    contact: "جهة الاتصال",
    orderStatus: "حالة الطلب",
    paymentStatus: "حالة الدفع",
    orderPlaced: "تم تقديم الطلب",
    shipping: "الشحن",
    delivered: "تم التوصيل",
    extraAmountPay: "مبلغ إضافي للدفع",
    totalCostPay: "إجمالي التكلفة للدفع",
    acceptReject: "قبول / رفض",
    inbox: "صندوق الوارد",
    totalPayments: "إجمالي المدفوعات",
    pendingPayments: "المدفوعات المعلقة",
    amountPaidToVendor: "المبلغ المدفوع للبائع",
    makePayment: "إجراء الدفع",
    pay: "دفع",
    addNotification: "إضافة إشعار",
    sentTo: "أُرسل إلى",
    title: "العنوان",
    messages: "الرسائل",
    delete: "حذف",
    addSubAdmin: "إضافة مشرف فرعي",
    role: "الدور",
    add: "إضافة",
    platformCommission: "عمولة المنصة",
    tax: "الضريبة",
    responseTime: "زمن الاستجابة (بالساعات)",
    avgDeliveryTime: "متوسط وقت التوصيل (بالأيام)",
    save: "حفظ",
    orderCancellationTime: "وقت إلغاء الطلب (بالساعات)",
    orderExchangeTime: "وقت استبدال الطلب (بالأيام)",
    serviceFee: "رسوم الخدمة",
    general: "عام",
    timing: "الوقت",
    contactSupport: "الاتصال بالدعم",
    privacyPolicy: "سياسة الخصوصية",
    agreement: "الاتفاقية",
    terms: "الشروط والأحكام",
    cookiesPolicy: "سياسة ملفات تعريف الارتباط",
    about: "حول",
    dataDeletion: "سياسة حذف البيانات",
    conversionRate: "سعر التحويل",
    conversionUsdToAed: "سعر التحويل من الدولار إلى الدرهم",
    viewUserProfile: "عرض ملف العميل",
    back: "رجوع",
    details: "تفاصيل",
    documents: "المستندات",

    city: "المدينة",
    pinCode: "الرمز البريدي",
    uploadedDocs: "المستندات المرفوعة",
    clickToDownload: "انقر لتحميل ملف PDF",
    selectIndustry: "اختر نوع الصناعة",
    categoryEn: "اسم الفئة باللغة الإنجليزية",
    categoryAr: "اسم الفئة باللغة العربية",
    categoryRu: "اسم الفئة باللغة الروسية",
    addCat: "إضافة فئة",
    editCat: "تعديل الفئة",
    productNameEn: "اسم المنتج (بالإنجليزية)",
    productNameAr: "اسم المنتج (بالعربية)",
    productNameRu: "اسم المنتج (بالروسية)",
    gradeEn: "الدرجة (بالإنجليزية)",
    gradeAr: "الدرجة (بالعربية)",
    gradeRu: "الدرجة (بالروسية)",
    modelEn: "رقم الموديل (بالإنجليزية)",
    modelAr: "رقم الموديل (بالعربية)",
    modelRu: "رقم الموديل (بالروسية)",
    images: "الصور",
    editProduct: "تعديل المنتج",
    shelfEn: "مدة الصلاحية (بالإنجليزية)",
    shelfAr: "مدة الصلاحية (بالعربية)",
    shelfRu: "مدة الصلاحية (بالروسية)",
    styleEn: "النمط (بالإنجليزية)",
    styleAr: "النمط (بالعربية)",
    styleRu: "النمط (بالروسية)",
    productTypeEn: "نوع المنتج (بالإنجليزية)",
    producTypeAr: "نوع المنتج (بالعربية)",
    productTypeRu: "نوع المنتج (بالروسية)",
    placeOfOrigin: "بلد المنشأ",
    stock: "الكمية المتوفرة",
    priceUnit: "وحدة السعر",
    select: "اختر",
    makeAsPackage: "جعله كحزمة",
    quantityPerUnit: "الكمية لكل وحدة",
    pricePerUnit: "السعر لكل وحدة",
    minPerchaseQty: "الحد الأدنى للشراء (بالوحدة)",
    descEng: "الوصف (بالإنجليزية)",
    descAr: "الوصف (بالعربية)",
    descRu: "الوصف (بالروسية)",
    bulkPricing: "تسعير الجملة",
    minQty: "الحد الأدنى للكمية",
    maxQty: "الحد الأقصى للكمية",
    remove: "إزالة",
    addBulk: "إضافة تسعير الجملة",
    pricePerKg: "السعر لكل كيلوجرام",
    pricePerLiter: "السعر لكل لتر",
    minQtyKg: "الحد الأدنى للشراء (بالكيلوجرام)",
    minQtyLiter: "الحد الأدنى للشراء (باللتر)",
    selectDateRange: "اختر نطاق التاريخ",
    quotedSubmitted: "تم تقديم العرض",
    quoteNotSubmitted: "لم يتم تقديم العرض",
    editBanner: "تعديل البانر",
    createBannerFor: "إنشاء بانر لـ",
    discountNameEn: "اسم الخصم باللغة الإنجليزية",
    discountNameAr: "اسم الخصم باللغة العربية",
    discountNameRu: "اسم الخصم باللغة الروسية",
    discountPer: "نسبة الخصم",
    addBannerImage: "إضافة صورة البانر",
    orderDetails: "تفاصيل الطلب",
    customerDetails: "تفاصيل العميل",
    productsOrdered: "المنتجات المطلوبة",
    regNo: "الرقم المسجل",
    orderedQty: "الكمية المطلوبة",
    myProfile: "ملفي الشخصي",
    changePassword: "تغيير كلمة المرور",
    logout: "تسجيل الخروج",
    currentPass: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmPass: "تأكيد كلمة المرور",
    daily: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري",
    yearly: "سنوي",
    customerRejected: "تم رفض العميل بنجاح",
    customerAccepted: "تم قبول العميل بنجاح",
    userDeleted: "تم حذف المستخدم بنجاح",
    customerActivated: "تم تفعيل العميل بنجاح",
    customerDeactivated: "تم إلغاء تفعيل العميل بنجاح",
    requestReceived: "تم استلام الطلب",
    vendorAccepted: "تم قبول البائع",
    vendorRejected: "تم رفض البائع",
    pickupScheduled: "تم جدولة الاستلام",
    pickedUp: "تم الاستلام",
    inTransit: "في الطريق",
    receivedByVendor: "تم الاستلام من قبل البائع",
    returnComplete: "تم إكمال الإرجاع",
    vendorAcceptedReq: "قبل البائع الطلب",
    vendorRejectedReq: "رفض البائع الطلب",
    ExchangeInit: "تم بدء عملية الاستبدال",
    itemPickedUp: "تم استلام العنصر",
    itemInTransit: "العنصر في الطريق",
    itemReceivedByVendor: "تم استلام العنصر من قبل البائع",
    replacementDispatched: "تم إرسال البديل",
    replacementDelivered: "تم تسليم البديل",
    exchangeComplete: "تم اكتمال عملية الاستبدال",
    returnStatusUpdatedTo: "تم تحديث حالة الإرجاع إلى",
    exchangeStatusUpdatedTo: "تم تحديث حالة الاستبدال إلى",
    orderAcceptedSuccessFully: "تم قبول الطلب بنجاح",
    orderRejectedSuccessfully: "تم رفض الطلب بنجاح",
    updatedSuccess: "تم التحديث بنجاح",
    send: "إرسال",
    editVendor: "تعديل البائع",
    vendorProfile: "ملف البائع",
    profileDetails: "تفاصيل الملف الشخصي",
    docs: "المستندات",
    areYouSure: "هل أنت متأكد أنك تريد الحذف؟",
    yes: "نعم",
    no: "لا",
    productAdded: "تمت إضافة المنتج بنجاح",
    productUpdated: "تم تحديث المنتج بنجاح",
    productDetails: "تفاصيل المنتج",
    sendQuotation: "إرسال عرض السعر",
    chatInbox: "صندوق المحادثات",
    typeMessage: "اكتب رسالتك...",
    chatDetails: "تفاصيل المحادثة",
    timeFrame: "الإطار الزمني (بالساعات)",
    selectProduct: "اختر المنتج",
    lastWeek: "الأسبوع الماضي",
    lastMonth: "الشهر الماضي",
    lastYear: "العام الماضي",
    bannerDetails: "عرض تفاصيل البانر",
    uploadBanner: "يرجى تحميل صورة للبانر",
    bannerUpdated: "تم تحديث البانر بنجاح",
    bannerAdded: "تمت إضافة البانر بنجاح",
    discountDetails: "عرض تفاصيل الخصم",
    discountAdded: "تمت إضافة الخصم بنجاح",
    discountUpdated: "تم تحديث الخصم بنجاح",
    editDiscount: "تعديل الخصم",
    accepted: "تم القبول",
    refundedSuccess: "تم الاسترداد بنجاح",
    exchangeRefunds: "مبالغ استرداد التبادل",
    returnRefunds: "مبالغ استرداد الإرجاع",
    refunded: "تم الاسترداد",
    notificationTitle: "عنوان الإشعار",
    notificationMessage: "رسالة الإشعار",
    receiverType: "اختر نوع المستلم",
    notificationType: "اختر نوع الإشعار",
    notification: "إشعار",
    settingsAdded: "تمت إضافة الإعدادات بنجاح",
    settingsUpdated: "تم تحديث الإعدادات بنجاح",
    addSettings: "إضافة إعداد",
    selectType: "اختر النوع",
    taxPer: "الضريبة (%)",
    commissionPer: "عمولة المنصة (%)",
    cmsUpdated: "تم تحديث دعم التواصل بنجاح",
    conversionUpdated: "تم تحديث سعر التحويل بنجاح",
    selectRole: "يرجى اختيار دور",
    editSubAdmin: "تعديل المشرف الفرعي",
    addRole: "إضافة دور",
    selectRole1: "اختر الدور",
    module: "الوحدة",
    addEdit: "إضافة/تعديل",
    view: "عرض",
    loginSuccess: "تم تسجيل الدخول بنجاح.",
    profileUpdated: "Profile Updated Successfully.",
    subAdminUpdated: "Sub Admin Status Updated successfully.",
    broadcast: "Broadcast",
    user: "User",
    vendor: "Vendor",
    selectAll: "Select All",
    remarks: "Remarks",
    amount: "Amount",
    showing: "Showing",
    items: "Items",
    exchange: "Exchange",
    return: "Return",
    updateDiscount: "Update Discount",
    discountActivated: "Discount Activated Successfully",
    discountDeactivated: "Discount Deactivated Successfully",
    passChanged: "Password changed successfully",
  },
  dashboard: {},
  sideBar: {
    dashboard: "لوحة التحكم",
    registration: "التسجيل",
    manageCustomers: "إدارة العملاء",
    manageVendors: "إدارة البائعين",
    manageCategories: "إدارة الفئات",
    manageProducts: "إدارة المنتجات",
    manageQuotes: "إدارة العروض",
    manageBanners: "إدارة اللافتات",
    manageDiscount: "إدارة الخصومات",
    manageOrders: "إدارة الطلبات",
    manageReturnExchange: "إدارة الإرجاع والاستبدال",
    manageRefunds: "إدارة المبالغ المستردة",
    manageChats: "إدارة الدردشات",
    managePayments: "إدارة المدفوعات",
    analytics: "تحليلات",
    notificationManagement: "إدارة الإشعارات",
    manageSubAdmin: "إدارة المسؤولين الفرعيين",
    settings: "الإعدادات",
    general: "عام",
    manageCms: "إدارة نظام إدارة المحتوى",
    conversionRate: "سعر التحويل",
  },
  error: {
    required: "هذا الحقل مطلوب",
    validation1: "الرجاء اختيار فيديو صالح",
    maxValidation: "الحد الأقصى المسموح به 80 حرفًا",
    minValidation: "الحد الأدنى المطلوب 3 أحرف",
    noData: "لم يتم العثور على نتائج",
    titlereq: "العنوان مطلوب",
    descReq: "الوصف مطلوب",
    noFaq: "لم يتم العثور على قائمة الأسئلة الشائعة",
    emailReq: "البريد الإلكتروني مطلوب!",
    validEmail: "أدخل عنوان بريد إلكتروني صالح!",
    firstReq: "الاسم الأول مطلوب",
    lastReq: "اسم العائلة مطلوب",
    phoneReq: "رقم الهاتف مطلوب",
    minPhone: "يجب أن يكون رقم الهاتف 6 أرقام على الأقل",
    maxPhone: "يجب أن يكون رقم الهاتف 16 رقمًا كحد أقصى",
    subAdminCreated: "تم إنشاء المسؤول الفرعي بنجاح",
    subAdminUpdate: "تم تحديث المسؤول الفرعي بنجاح",
    userUpdate: "تم تحديث المستخدم بنجاح",
    statusUpdate: "تم تحديث الحالة بنجاح",
    subAdminDel: "تم حذف المسؤول الفرعي بنجاح",
    userDel: "تم حذف المستخدم بنجاح",
    max100: "الحد الأقصى المسموح به 100 حرف",
    max250: "الحد الأقصى المسموح به 250 حرفًا",
    max500: "الحد الأقصى المسموح به 500 حرف",
    catAdd: "تم إضافة الفئة بنجاح",
    catUpdate: "تم تحديث الفئة بنجاح",
    settingUpdate: "تم تحديث الإعدادات بنجاح",
    faqAdd: "تم إضافة الأسئلة الشائعة بنجاح",
    faqDel: "تم حذف الأسئلة الشائعة بنجاح",
    cmsUpdate: "تم تحديث CMS بنجاح",
    messageReq: "الرسالة مطلوبة",
    notiAdd: "تم إضافة الإشعار بنجاح",
    notiDel: "تم حذف الإشعار بنجاح",
    logutReq: "هل أنت متأكد من أنك تريد تسجيل الخروج؟",
    noUserFound: "لم يتم العثور على مستخدم",
    noVendorFound: "لم يتم العثور على بائع",
    noSubFound: "لم يتم العثور على فئة فرعية",
    noChatFound: "لم يتم العثور على محادثات",
    noDocs: "لا توجد مستندات متاحة.",
    noImage: "يرجى تحميل صورة",
    incorrectOtp: "رمز التحقق غير صحيح. حاول مرة أخرى.",
    enterOtp: "يرجى إدخال رمز التحقق",
    noEmoji: "لا يُسمح باستخدام الرموز التعبيرية في عنوان البريد الإلكتروني",
    newPassReq: "كلمة المرور الجديدة مطلوبة.",
    passValid:
      "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل، وتشمل حرفًا كبيرًا واحدًا، وحرفًا صغيرًا واحدًا، ورقمًا واحدًا، وحرفًا خاصًا واحدًا (@$!%*?&)",
    newCannotBeOld: "لا يمكن أن تكون كلمة المرور الجديدة هي نفسها الحالية.",
    mustMatch: "يجب أن تتطابق كلمتا المرور.",
    confirmPassReq: "تأكيد كلمة المرور مطلوب.",
    passReset: "تمت إعادة تعيين كلمة المرور بنجاح",
    max40: "الحد الأقصى هو 80 حرفًا",
    pleaseUploadImage: "يرجى تحميل الصور",
    fillMinimum: "يرجى إدخال الكمية الدنيا",
    fillMaximum: "يرجى إدخال الكمية القصوى",
    fillPrice: "يرجى إدخال السعر",
    max10Image: "الحد الأقصى هو 10 صور",
    pleaseWrite: "يرجى كتابة شيء",
    minBanner: "يجب أن تكون أبعاد صورة البانر بحد أدنى 498×500",
    atLeast1Receiver: "يرجى اختيار مستلم واحد على الأقل",
    oneNotificationType: "يرجى اختيار نوع إشعار واحد على الأقل",
    currentPassRequired: "Current password is required",
    min8: "Minimum 8 characters are required",
  },
  messages: {},
};
